import React, { useState, useEffect } from 'react';
import { api } from '../api';

export default function HotelsPage() {
  const [hotels, setHotels] = useState([]);
  const [modal, setModal]   = useState(false);
  const [form, setForm]     = useState({ name: '', tl_hotel_id: '', has_tl_access: false });

  const load = async () => { setHotels(await api.hotels()); };
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  const save = async () => {
    if (!form.name.trim()) { alert('Введите название'); return; }
    try {
      await api.createHotel({
        name: form.name.trim(),
        tl_hotel_id: form.tl_hotel_id ? parseInt(form.tl_hotel_id) : null,
        has_tl_access: form.has_tl_access,
      });
      setModal(false);
      setForm({ name: '', tl_hotel_id: '', has_tl_access: false });
      await load();
    } catch(e) { alert(e.message); }
  };

  const deactivate = async (id, name) => {
    if (!window.confirm(`Деактивировать отель "${name}"?`)) return;
    try { await api.deleteHotel(id); await load(); }
    catch(e) { alert(e.message); }
  };

  const toggleTL = async (hotel) => {
    try {
      await api.updateHotel(hotel.id, { has_tl_access: !hotel.has_tl_access });
      await load();
    } catch(e) { alert(e.message); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Отели</h1>
        <button className="btn btn-primary" onClick={() => setModal(true)}>+ Добавить отель</button>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>Название</th><th>TL Hotel ID</th><th>Источник</th><th>Статус</th><th></th></tr>
            </thead>
            <tbody>
              {hotels.map(h => (
                <tr key={h.id}>
                  <td><strong>{h.name}</strong></td>
                  <td style={{ color:'#636e72', fontSize:13 }}>{h.tl_hotel_id || '—'}</td>
                  <td>
                    <span className={h.has_tl_access ? 'source-tl' : 'source-manual'}>
                      {h.has_tl_access ? 'TravelLine' : 'Ручной ввод'}
                    </span>
                  </td>
                  <td>
                    <span style={{ color: h.is_active ? '#00b894' : '#d63031', fontWeight:600 }}>
                      {h.is_active ? 'Активен' : 'Деактивирован'}
                    </span>
                  </td>
                  <td style={{ display:'flex', gap:6 }}>
                    <button className="btn btn-secondary btn-sm" onClick={() => toggleTL(h)}>
                      {h.has_tl_access ? '→ Ручной' : '→ TL'}
                    </button>
                    {h.is_active && (
                      <button className="btn btn-danger btn-sm" onClick={() => deactivate(h.id, h.name)}>
                        Деактивировать
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-title">Добавить отель</div>
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div className="form-group">
                <label>Название отеля *</label>
                <input value={form.name} onChange={e=>set('name',e.target.value)}
                  placeholder="Номера на Примерной" autoFocus />
              </div>
              <div className="form-group">
                <label>Источник данных</label>
                <div style={{ display:'flex', gap:16, marginTop:4 }}>
                  <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                    <input type="radio" checked={!form.has_tl_access}
                      onChange={() => set('has_tl_access', false)} />
                    <span>Ручной ввод (нет TL)</span>
                  </label>
                  <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                    <input type="radio" checked={form.has_tl_access}
                      onChange={() => set('has_tl_access', true)} />
                    <span>TravelLine</span>
                  </label>
                </div>
              </div>
              {form.has_tl_access && (
                <div className="form-group">
                  <label>TL Hotel ID</label>
                  <input type="number" value={form.tl_hotel_id}
                    onChange={e=>set('tl_hotel_id', e.target.value)}
                    placeholder="46844" />
                </div>
              )}
              <div style={{ background:'#f8f9fa', borderRadius:8, padding:'10px 14px', fontSize:13, color:'#636e72' }}>
                {form.has_tl_access
                  ? 'Данные будут синхронизироваться автоматически из TravelLine'
                  : 'Администратор отеля будет вносить данные вручную'}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal(false)}>Отмена</button>
              <button className="btn btn-primary" onClick={save}>Добавить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
